import BaseQuestion from "./BaseQuestion";
import BaseAnswer from "./BaseAnswer";
import SubQuestion from "./SubQuestion";

export default class extends BaseQuestion {

    constructor(dto) {
        super(dto);

        this.IsVisible = true;
        this.Prompt = dto.Prompt;
        this.IsPhotoRequired = dto.IsPhotoRequired;
        this.MainVisiblePoliticList = dto.MainVisiblePoliticList;
        this.Comment = dto.Comment;
        
        this.StatusClass = this.IsAnswered ? "got-answer-positive" : "got-answer-negative";
        this.StatusText = this.IsAnswered ? "Ответ получен" : "Ответ не получен";

        this.AnswerList = dto.AnswerList.map(e => new MainAnswer(e));
    }

    get Selected() {
        let selected = this.AnswerList.find(e => Boolean(e.Selected));

        return Boolean(selected) ? selected.Value.Key : null;
    }

    set Selected(key) {        
        this.AnswerList.forEach(e => { 
            if(key == e.Value.Key)
                e.Selected = true;
            else
                e.Selected = null 
        }); 
    }
}

class MainAnswer extends BaseAnswer {
    constructor(dto) {
        super(dto);

        this.SubQuestionList = dto.SubQuestionList.map(e => new SubQuestion(e));
    }
}